import { createStore } from 'vuex';
import { userModule } from './user.module';

export default createStore({
	modules: {
		userModule,
	},
});
